import { createApi } from '@reduxjs/toolkit/query/react'
import baseQuery from 'services'
import { IPaginationQueryInfo } from 'types/pagination'
import { IPaymentHistory, IPaymentsHistory, TPaymentPayerStatus, TPaymentResponse } from 'types/payments'

export const paymentsApi = createApi({
  reducerPath: 'payment',
  tagTypes: ['PaymentHistory', 'PaymentPayerStatus'],
  baseQuery,
  endpoints: (builder) => ({
    paymentsHistory: builder.query<IPaymentsHistory, IPaginationQueryInfo>({
      query: (params) => ({
        url: '/payments/history',
        method: 'get',
        params,
      }),
      providesTags: ['PaymentHistory'],
    }),

    payments: builder.mutation<TPaymentResponse, Partial<IPaymentHistory>>({
      query: (params) => ({
        url: '/payments',
        method: 'get',
        params,
      }),
      invalidatesTags: ['PaymentHistory'],
    }),

    paymentPayerStatus: builder.query<TPaymentPayerStatus, { lotId: string }>({
      query: (params) => ({
        url: '/payments/payer-status',
        method: 'get',
        params,
      }),
      providesTags: ['PaymentPayerStatus'],
    }),
  }),
})

export const {
  usePaymentsMutation,
  usePaymentsHistoryQuery,
  usePaymentPayerStatusQuery,
} = paymentsApi
